module.exports = __webpack_public_path__ + "img/video_icon02.f71a666c.png";